import { render, staticRenderFns } from "./BackupFirestore.vue?vue&type=template&id=5056c29d"
import script from "./BackupFirestore.vue?vue&type=script&lang=js"
export * from "./BackupFirestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports